import wixWindow from "wix-window";
import { Bi } from "public/bi";

$w.onReady(async function() {
  
  
});
